import { connect } from 'react-redux';

import CompareBidsModal from './CompareBidsModal';
import { requestCompareBids } from "../modules/tour";

const mapDispatchToProps = {
    requestCompareBids
};

const mapStateToProps = state => ({
    tour: state.tours.selectedTour.tour,
    compareBids: state.tours.compareBids

});
const CompareBidsContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(CompareBidsModal);
export default CompareBidsContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/CompareBidsContainer.js